import { render } from "./ListElement.vue?vue&type=template&id=58ceb069&scoped=true"
import script from "./ListElement.vue?vue&type=script&lang=js"
export * from "./ListElement.vue?vue&type=script&lang=js"

import "./ListElement.vue?vue&type=style&index=0&id=58ceb069&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ceb069"]])

export default __exports__